import { HTTP } from '@community_dev/requests'

import { ENDPOINTS } from 'constants/endpoints'
import { request } from 'utils/api'

export type Context = {
  name: string
  active: boolean
  campaignMessagesMonthlyThreshold: number
  campaignMessagesMonthlyUsed: number
  clientId: string
  clientImage: string
  currentContext: true
  firstName: string
  lastName: string | null
  onboardingBillingState: {
    billingProvided: boolean
    billingRequired: boolean
    trialLengthDays: string
    trialStarted: boolean
  }
  phoneNumber: string
}

type SelectContextResponse<Token = string> = {
  data: {
    id: string
    seatId: string
    token: Token
  }
  jwt: Token
}

export function getContexts(token?: string): Promise<Context[]> {
  return request(ENDPOINTS.CONTEXT, {
    token,
  }).then(({ data }) => {
    return data.map((context) => {
      const firstName = context.firstName || ''
      const lastName = context.lastName || ''
      const { billingProvided, billingRequired } = context.onboardingBillingState

      return {
        ...context,
        name: `${firstName} ${lastName}`.trim(),
        active: billingRequired ? billingProvided : true,
      }
    })
  })
}

export function putSelectContext({
  context,
  token,
}: {
  context: string
  token?: string
}): Promise<SelectContextResponse> {
  return request(ENDPOINTS.CONTEXT, {
    body: { context },
    token,
    method: HTTP.PUT,
    headers: { 'cache-control': 'no-cache' },
  })
}
